import { ImageMagick, MagickFormat, MagickGeometry } from '@imagemagick/magick-wasm'

interface CompressOptions {
  quality: number
  maxWidth: number
  maxHeight: number
}

export async function imageCompression(inputBlob: Blob, options: CompressOptions): Promise<Blob> {
  // BlobをUint8Arrayに変換
  const arrayBuffer = await inputBlob.arrayBuffer()
  const uint8Array = new Uint8Array(arrayBuffer)
  return await new Promise<Blob>((resolve, reject) => {
    try {
      // 読込
      ImageMagick.read(uint8Array, image => {
        // Orientation（回転）を自動補正
        image.autoOrient()

        // リサイズ設定
        if (image.width > options.maxWidth || image.height > options.maxHeight) {
          const geometry = new MagickGeometry(options.maxWidth, options.maxHeight)
          image.resize(geometry)
        }

        // 品質設定
        image.quality = Math.floor(options.quality * 100)

        // Jpegとして書き出し
        image.write(MagickFormat.Jpeg, data => {
          const uint8 = new Uint8Array(data.buffer as ArrayBuffer, data.byteOffset, data.byteLength)
          const outputBlob = new Blob([uint8], { type: 'image/jpeg' })
          resolve(outputBlob)
        })
      })
    } catch (e) {
      console.debug(e)
      reject(e)
    }
  })
}
